module.exports = __webpack_public_path__ + "static/media/Rotom_gaussian2.48c1600d.png";